import { Button } from '@material-ui/core';
import React from 'react';

import { property } from 'lodash-es';
import defaults from '../../translations/en.json';
import { requiredFields } from './constants';
import { apply } from './utils';

const isTruthy = (a: any) => !!a;

const areEditsComplete = (edits: any) =>
  edits && requiredFields.map(property).map(apply(edits)).every(isTruthy);

type IncidentEditButtonsProps = {
  editState: any;
  onAdd: () => void;
  onSave: () => void;
  onCancel: () => void;
};

export const IncidentEditButtons = ({
  editState,
  onAdd,
  onSave,
  onCancel,
}: IncidentEditButtonsProps) => {
  const editing = !!editState;
  return (
    <div style={{ display: 'flex', flexDirection: 'row', gap: '4px' }}>
      <Button onClick={onAdd} disabled={editing} variant="outlined">
        {defaults.ADD_INCIDENT}
      </Button>
      {editing && (
        <>
          <Button
            onClick={onSave}
            disabled={!areEditsComplete(editState)}
            variant="outlined"
          >
            {defaults.SAVE}
          </Button>
          <Button onClick={onCancel} variant="outlined">
            {defaults.CANCEL}
          </Button>
        </>
      )}
    </div>
  );
};
